import {
  TOGGLE_AREA_ENTRY_STRATEGY,
  TOGGLE_AREA_ENTRY_STRATEGY_ERROR,
  TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
  message: null,
};

const toggleAreaEntryStrategyReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_AREA_ENTRY_STRATEGY:
      state = {
        ...state,
        loading: true,
        error: null,
        message: null,
      };
      break;
    case TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS:
      state = {
        ...state,
        loading: false,
        message: action.payload.message,
        error: null,
      };
      break;
    case TOGGLE_AREA_ENTRY_STRATEGY_ERROR:
      state = {
        ...state,
        loading: false,
        message: null,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default toggleAreaEntryStrategyReducer;
